import React from "react";
import BondRetrievalDetailedInformationBase from "./BondRetrievalDetailedInformationBase";
import { RETRIEVAL_DETAILED_INFO_CONFIG } from "../bondRetrievalDetailedInformationConfig";

const DetailedInformation = (props) => (
  <BondRetrievalDetailedInformationBase
    config={RETRIEVAL_DETAILED_INFO_CONFIG.blanket}
    {...props}
  />
);

export default DetailedInformation;
